import { useId, type InputHTMLAttributes } from 'react';
import styles from './Field.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly label: string;
  /** Unit shown after the value, e.g. `ms`. */
  readonly unit?: string;
}

export function Input({ label, unit, id, onKeyDown, ...rest }: InputProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className={styles.field}>
      <label htmlFor={inputId} className={styles.label}>
        {label}
      </label>
      <div className={styles.control}>
        <input
          id={inputId}
          className={styles.input}
          onKeyDown={(e) => {
            if (e.key === 'Delete' || e.key === 'Backspace') {
              e.stopPropagation();
            }
            onKeyDown?.(e);
          }}
          {...rest}
        />
        {unit !== undefined && <span className={styles.unit}>{unit}</span>}
      </div>
    </div>
  );
}
